import type * as React from 'react';
import type { FC } from 'react';

import {
  ClassNotes as ClassNotesModule,
  type MyNotesProps,
} from '@/shared/components';

import {
  ENROLLMENTS_COURSES_ROUTE,
  ENROLLMENTS_ROUTE_PATH,
} from '../route-paths';

const ClassNotes: FC<React.PropsWithChildren<MyNotesProps>> = props => (
  <ClassNotesModule
    {...props}
    enrollmentsCoursesRoutePath={ENROLLMENTS_COURSES_ROUTE.path}
    enrollmentsRoutePath={ENROLLMENTS_ROUTE_PATH}
  />
);

export default ClassNotes;
